var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgK8SPersistentVolumeClaim = function SvgK8SPersistentVolumeClaim(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 10.5H1V12a1.003 1.003 0 0 0 1 1h1.5v-1H2zM2 4h1.5V3H2a1.003 1.003 0 0 0-1 1v1.5h1zM11.5 3h-3v1h3zM7.5 3h-3v1h3zM11.5 12h-3v1h3zM14 7.5H2v-1H1v3h1v-1h12v1h1v-3h-1zM14 12h-1.5v1H14a1.003 1.003 0 0 0 1-1v-1.5h-1zM14 3h-1.5v1H14v1.5h1V4a1.003 1.003 0 0 0-1-1M7.5 12h-3v1h3zM3.5 6.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1M3.5 10.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1"
  })));
};
export default SvgK8SPersistentVolumeClaim;